export const ROUTE_SECURITY = '/security';

export const ROUTE_APPROVAL_RULES = `${ROUTE_SECURITY}/approval-rules`;
